import { WIDTH_PROGRESSBAR } from "./constants";

export const calcProgressbarPixels = ({
  userExperience,
  prevRankExperience,
  rankExperience,
  isFinal = false,
}: {
  userExperience: number;
  prevRankExperience: number;
  rankExperience: number;
  isFinal: boolean;
}) => {
  const progressRank = rankExperience - prevRankExperience;
  const progressUserCurrentRank = userExperience - prevRankExperience;

  if (isFinal && userExperience > prevRankExperience) {
    return WIDTH_PROGRESSBAR;
  }

  if (progressUserCurrentRank <= 0) {
    return 0;
  }

  if (progressUserCurrentRank >= progressRank) {
    return WIDTH_PROGRESSBAR;
  }

  return Math.floor(
    (progressUserCurrentRank / progressRank) * WIDTH_PROGRESSBAR,
  );
};
